import { FileExcelOutlined } from '@ant-design/icons';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const bulkUploadGuide: FeatureGuide = {
    key: 'bulkUpload',
    title: 'Bulk Upload',
    icon: <FileExcelOutlined />,
    sections: [
        whatItIs('An optional spreadsheet holding many goods items, uploaded to the declaration in one go.'),
        howItHelps(
            'Bulk upload replaces item-by-item entry on large consignments, which saves time and avoids transcription mistakes.'
        ),
        tips([
            'Keep the column order of the provided file format intact.',
            'Check the totals against the invoice before uploading.',
        ]),
    ],
};
